import type { ViewFieldsFragment } from '@salescore/client-api'
import type { CompiledFormViewConfig, ViewUIFormList } from '@salescore/core'
import { Empty, Form, Row, Space } from 'antd'
import type { FormListFieldData } from 'antd/es/form/FormList'
import type { ReactElement } from 'react'
import * as React from 'react'

import type { SalescoreObjectAbility, ViewAbility } from '../../recoil/view/atoms'
import { ViewUIFormComponentC } from './ViewUIComponent'

export const ViewUIFormListContext = React.createContext<{
  formListField: FormListFieldData | undefined
}>({
  formListField: undefined,
})

export const ViewUIFormListC = ({
  component,
  compiledConfig,
  showError,
  view,
  ability,
}: {
  component: ViewUIFormList
  compiledConfig: CompiledFormViewConfig
  showError: boolean
  view: ViewFieldsFragment
  ability: ViewAbility & SalescoreObjectAbility
}): ReactElement => (
  <div className="mt-6 rounded-lg bg-gray-100 px-4 py-2">
    <Form.List name={component.path}>
      {(fields) => (
        <div>
          <Space>
            <div className="mb-2 font-bold">{component.label}</div>
          </Space>
          {fields.map((formListField) => (
            <Row
              key={formListField.key}
              gutter={16}
              className="mb-4 rounded-lg border border-solid border-gray-100 bg-white p-3"
            >
              <ViewUIFormListContext.Provider value={{ formListField }}>
                {component.children.map((child, index) => (
                  <ViewUIFormComponentC
                    key={`${child.type}_${index}`}
                    component={child}
                    compiledConfig={compiledConfig}
                    showError={showError}
                    view={view}
                    ability={ability}
                  />
                ))}
              </ViewUIFormListContext.Provider>
            </Row>
          ))}
          {fields.length === 0 && <Empty className="mb-4" />}
        </div>
      )}
    </Form.List>
  </div>
)
